import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Import Tailwind CSS
import './styles/globals.css';
// Variables et composants CSS de common (PAS base.css ni utilities.css qui cassent Tailwind)
import '@common/styles/components.css';
import '@common/styles/variables.css';
// Styles admin specifiques
import './styles/admin.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <React.Suspense
        fallback={
          <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
            <img src="/logo-seul.png" alt="SingSpace" className="w-20 h-20 mb-4 animate-pulse" />
            <p className="text-sm text-slate-600 font-medium">Chargement...</p>
          </div>
        }
      >
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <App />
        </BrowserRouter>
      </React.Suspense>
    </QueryClientProvider>
  </React.StrictMode>,
);
